export const siteContent = {
  businessName: 'T. Anderson Enterprises',
  shortName: 'TAE',
  ownerName: 'T. Anderson',
  headline: 'Senior software development and cloud consulting for teams that need durable systems.',
  summary:
    'A 10+ year software developer and engineering leader with enterprise and startup experience across full-stack product delivery, managed service provider platforms, cloud architecture, security tooling, and team leadership.',
  services: [
    {
      title: 'Custom Application Development',
      description:
        'Design and implementation for internal tools, customer-facing web applications, APIs, automation, integrations, and modernization efforts.',
    },
    {
      title: 'Cloud and Platform Consulting',
      description:
        'Practical architecture guidance for Azure and AWS workloads, containerized deployments, CI/CD, serverless systems, and operational readiness.',
    },
    {
      title: 'Technical Leadership',
      description:
        'Delivery planning, architecture review, mentoring, implementation standards, and hands-on support for teams building business-critical software.',
    },
  ],
  accomplishments: [
    'Built and supported RMM product capabilities at an MSP-focused organization generating more than $100M in revenue.',
    'Contributed to software installed on millions of computers worldwide.',
    'Led developer teams for 4 years across delivery, planning, mentoring, and technical execution.',
    'Currently manages a security-related MSP tool protecting remote managed computers and surfacing behavior analytics.',
  ],
  stackGroups: [
    {
      title: 'Languages',
      items: ['C#', 'TypeScript', 'JavaScript', 'PHP', 'Go', 'Ruby'],
    },
    {
      title: 'Cloud',
      items: ['Azure', 'AWS', 'AKS', 'Functions', 'Lambdas', 'RDS', 'ECS', 'ECR', 'SQS', 'SES', 'SMS'],
    },
    {
      title: 'Delivery',
      items: ['GitHub', 'TFS', 'Kubernetes', 'Argo', 'Managed Identities', 'Security Groups'],
    },
  ],
};

